// Function index:
//   mountChroniclePanel(partyId) — wire the Chronicle button + overlay (like
//       mountLedgerPanel). A chronicle.recap push (via setRecapEntries)
//       badge-pulses the button and primes the FIRST open with exactly what
//       the user missed; every later open fetches the latest entries.
//   setRecapEntries(entries) — module hook the ws binding calls on
//       chronicle.recap.

import { getChronicle, type ChronicleEntry } from '../api.js';
import { relTime } from '../format-time.js';

let recap: ChronicleEntry[] | null = null;

export function setRecapEntries(entries: ChronicleEntry[]): void {
  recap = entries;
  document.getElementById('chronicle-btn')?.classList.add('badge-pulse');
}

export function mountChroniclePanel(partyId: number): void {
  const btn = document.getElementById('chronicle-btn') as HTMLButtonElement;
  const overlay = document.getElementById('chronicle-overlay') as HTMLDivElement;
  const close = document.getElementById('chronicle-close') as HTMLButtonElement;
  const subtitle = document.getElementById('chronicle-subtitle') as HTMLDivElement;
  const error = document.getElementById('chronicle-error') as HTMLDivElement;
  const worldHost = document.getElementById('chronicle-world') as HTMLDivElement;
  const partyHost = document.getElementById('chronicle-party') as HTMLDivElement;

  function render(entries: ChronicleEntry[]): void {
    const world = entries.filter((e) => !e.mine);
    const party = entries.filter((e) => e.mine);
    worldHost.innerHTML = world.length > 0
      ? world.map(line).join('')
      : '<div class="ledger-empty">The wider world has been quiet…</div>';
    partyHost.innerHTML = party.length > 0
      ? party.map(line).join('')
      : '<div class="ledger-empty">Nothing new close to home…</div>';
  }

  async function load(): Promise<void> {
    error.hidden = true;
    btn.classList.remove('badge-pulse');
    if (recap) {
      // First open after a recap: show exactly what the user missed.
      subtitle.hidden = false;
      render(recap);
      recap = null;
      return;
    }
    subtitle.hidden = true;
    worldHost.innerHTML = '<div class="ledger-empty">loading…</div>';
    partyHost.innerHTML = '';
    try {
      const { entries } = await getChronicle(partyId);
      render(entries);
    } catch (err) {
      error.textContent = `Could not load the chronicle: ${(err as Error).message}`;
      error.hidden = false;
      worldHost.innerHTML = '';
      partyHost.innerHTML = '';
    }
  }

  btn.addEventListener('click', () => {
    overlay.hidden = false;
    void load();
  });
  const hide = (): void => { overlay.hidden = true; };
  close.addEventListener('click', hide);
  overlay.addEventListener('click', (e) => { if (e.target === overlay) hide(); });
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !overlay.hidden) hide();
  });
}

function line(e: ChronicleEntry): string {
  return `<div class="inv-row"><span class="nm">${esc(e.text)}</span><span class="kind">${relTime(e.created_at)}</span></div>`;
}

function esc(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]!));
}
